import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiErrorClear } from '../ducks/base-api';

export const useFormCleanup = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        return function cleanup() {
            dispatch(apiErrorClear());
        };
    }, []);

};